{
  "name": "grc-frontend",
  "version": "0.1.1-212",
  "engines": {
    "node": "^20.19.4"
  },
  "scripts": {
    "ng": "ng",
    "prestart": "node scripts/generate-env.js",
    "start": "ng serve --host 0.0.0.0 --port 4200 --configuration development --poll=500",
    "start:qa": "ng serve --configuration qa",
    "start:prod": "ng serve --configuration production",
    "start:staging": "ng serve --configuration staging",
    "build": "ng build",
    "prebuild:development": "node scripts/generate-env.js",
    "build:development": "ng build --configuration development",
    "build:qa": "ng build --configuration qa",
    "build:production": "ng build --configuration production",
    "build:staging": "ng build --configuration staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --browsers=ChromeHeadlessNoSandbox --watch=false",
    "lint": "eslint 'src/**/*.ts'",
    "lint:fix": "eslint --fix 'src/**/*.ts'",
    "format": "prettier --write 'src/**/*.ts' 'src/**/*.html' 'src/**/*.less'",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run --headless"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.1.0",
    "@angular/common": "^18.1.0",
    "@angular/compiler": "^18.1.0",
    "@angular/core": "^18.1.0",
    "@angular/forms": "^18.1.0",
    "@angular/localize": "^18.1.0",
    "@angular/platform-browser": "^18.1.0",
    "@angular/platform-browser-dynamic": "^18.1.0",
    "@angular/router": "^18.1.0",
    "@tinymce/tinymce-angular": "^8.0.0",
    "@types/googlemaps": "^3.43.3",
    "docx-preview": "^0.3.6",
    "dompurify": "^3.4.13",
    "jszip": "^3.10.1",
    "mammoth": "^1.12.1",
    "ng-zorro-antd": "^18.0.1",
    "ng2-pdf-viewer": "^10.3.4",
    "rxjs": "~7.8.0",
    "survey-angular-ui": "^1.9.109",
    "survey-core": "^1.9.109",
    "tinymce": "^7.5.1",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "^0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.1.0",
    "@angular-eslint/builder": "^18.1.0",
    "@angular-eslint/eslint-plugin": "^18.1.0",
    "@angular-eslint/eslint-plugin-template": "^18.1.0",
    "@angular-eslint/schematics": "^18.1.0",
    "@angular-eslint/template-parser": "^18.1.0",
    "@angular/cli": "^18.1.0",
    "@angular/compiler-cli": "^18.1.0",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^29.5.14",
    "@types/tinymce": "^4.6.9",
    "@typescript-eslint/eslint-plugin": "^7.15.0",
    "@typescript-eslint/parser": "^7.15.0",
    "cypress": "^13.7.2",
    "eslint": "^8.57.0",
    "jasmine-core": "^5.1.2",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.3.2",
    "typescript": "^5.5.3"
  }
}
